import React from "react";
import "./header.css";

export function Header() {
  return (
    <header>
      <div id="app-name">
        <img
          id="mimih-img"
          src="images/mimih.png"
          height="45px"
          alt="app logo"
        />
        <h1 id="app-title">
          <span>Bininj Kunwok</span>
          <span id="dictionary">phrasebook</span>
        </h1>
      </div>

      <div id="search-options">
        <p id="help">
          <span id="mobile-about">?</span>
          <span id="desktop-about">About</span>
        </p>
      </div>
    </header>
  );
}
